<script setup>

const props = defineProps({
  ann: {
    type: Object,
    required: true
  },
  editing: {
    type: Boolean,
    default: false
  }
})

import { VideoStore } from '@/front/stores/video_store.js';
import { PlayerStore } from '@/front/stores/player_store.js';
import { AnnStore } from '@/front/stores/ann_store.js';
const annStore = AnnStore();
import { PositionCalculator } from '@/front/composables/PositionCalculator.js';
const { calculatePosition } = PositionCalculator()
import { ClipStore } from '@/front/stores/clip_store.js';
const clipStore = ClipStore();
import ClipPlayer from '@/front/components/ClipPlayer.vue';
import Button from 'primevue/button';
import { Cancel01Icon } from 'hugeicons-vue';

const videoStore = VideoStore();
const playerStore = PlayerStore();

const customStyle = props.ann.customStyle && JSON.parse(props.ann.customStyle) || {}
log.info(5,customStyle)
const styling = computed(() => {
  const baseDesign = videoStore.video.design || {}
  const widthRatio = playerStore.playerState.width / customStyle.videoWidth

  const dimensions = calculatePosition(props.ann)
  return {
    shell: {
      'width': `${dimensions.width}px`,
      'height': `${dimensions.height}px`,
      'left': `${dimensions.left}px`,
      'top': `${dimensions.top}px`,
      // 'minHeight': `${dimensions.minHeight}px`,
      'maxHeight': '100%',
      'fontSize': `${dimensions.fontSize}px`,
      'textAlign': customStyle.textAlign || 'center',
      'border': '1px solid red',
    },
  }
})

const onClipEnded = () => {
  log.info(5,"LayerClip onClipEnded")
  if (annStore.isEditing || playerStore.isDev && videoStore.video.manage) {
    log.info(5,"LayerClip onClipEnded isEditing cancelling")
    return
  }
  clipStore.clear()
  playerStore.clipFinished()
}
</script>

<template>
  
  <div id="layer-clip" class="shadow-md" :style="styling.shell" :class="annStore.isEditing ?  'animate-none' : `${ann.animation} hover:scale-105 z-10`">
    <ClipPlayer v-if="clipStore.src" :clip="ann.content" :controls="false" @ended="false && onClipEnded" :loop="annStore.isEditing" class="h-full max-h-full"/>
  </div>

</template>

<style>
#layer-clip video {
  height: 100%;
}

</style>